export const MAP_SETTINGS_DIRECTIONS_SET_DIRECTION_SETTINGS = 'MAP_SETTINGS_DIRECTIONS/SET_DIRECTION_SETTINGS';
export const MAP_SETTINGS_DIRECTIONS_MODIFY_ROUTE = 'MAP_SETTINGS_DIRECTIONS/MODIFY_ROUTE';
